import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'multisite-flag',
    template: `<i class="flag-dim" aria-hidden="true" [ngClass]="'flag-' + country.toLowerCase()"></i>`,
    standalone: true,
    imports: [NgClass],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MultisiteFlagComponent {
    @Input({ required: true })
    country!: string;
}
